import { createContext, useContext, useState, useEffect } from 'react';

export const ThemeCtx = createContext();

export function ThemeProvider({ children }) {
  const [dark, setDark] = useState(true);

  // Apply class to <body> so CSS variables switch
  useEffect(() => {
    document.body.className = dark ? '' : 'light';
  }, [dark]);

  const toggle = () => setDark(d => !d);

  return (
    <ThemeCtx.Provider value={{ dark, toggle }}>
      {children}
    </ThemeCtx.Provider>
  );
}

// Convenient hook — use in any component
export const useTheme = () => useContext(ThemeCtx);
